<template>
  <div>
    <b-img class="mx-auto" fluid style="width: 200px; display:block;" id="titleimage" :src="require('../assets/logo_zekkenjockey.png')"></b-img>
    <div class="mx-auto" fluid style="width: 80%; display:block;" >
      <p id="codePreview">{{ codeUpperCase }}</p>

      <!-- <b-form>
        <b-input type="text" id="input_eventcode" v-model="code" placeholder="input an event code..." ref='input_code'/>
        <b-button type="submit" @click="forwardViewerPage(code)">のイベントを見る</b-button>
      </b-form> -->

      <!-- <b-input-group prepend="イベントコード" class="mt-3"> -->
      <b-input-group class="mt-3">
        <b-form-input autofocus id="input_eventcode" v-model="code" placeholder="イベントキーを入力して" @submit.prevent="enterNumber" @keyup.enter="forwardViewerPage(code)"></b-form-input>
        <b-input-group-append>
          <b-button type="submit" variant="outline-success"  @click="forwardViewerPage(code)">記録を見る</b-button>
        </b-input-group-append>
      </b-input-group>

    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      q: null,
      type: null,
      code: null,
      event_title: null
    }
  },
  computed: {
    codeUpperCase: function () {
      if (this.code === null || this.code === '') {
        return 'ランナーたちの記録を見よう！'
      }
      return 'イベントキー: ' + this.code.toUpperCase()
    }

  },
  mounted () {
    // this.$refs.input_code.focus()
  },
  methods: {
    forwardViewerPage: function (code) {
      this.$router.push({
        path: '/seats',
        query: {
          code: code,
          backable: true
        }
      })
    }
  }
}
</script>

<style>
#input_eventcode {
  font-size: 18px;
  padding: 2% 0 2% 4%;
  border-radius: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/entrance.vue